import BranchesAPI from '../../api/branches';

export const SET_BRANCH_MEMBERS_UI_FLAG = 'SET_BRANCH_MEMBERS_UI_FLAG';
export const ADD_AGENTS_TO_BRANCH = 'ADD_AGENTS_TO_BRANCH';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getBranchMembers: $state => id => {
    return $state.records[id] || [];
  },
};

export const actions = {
  get: async ({ commit }, { branchId }) => {
    commit(SET_BRANCH_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await BranchesAPI.getAgents({ branchId });
      commit(ADD_AGENTS_TO_BRANCH, { data, branchId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_BRANCH_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, { agentsList, branchId }) => {
    commit(SET_BRANCH_MEMBERS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await BranchesAPI.addAgents({ agentsList, branchId });
      commit(ADD_AGENTS_TO_BRANCH, { branchId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_BRANCH_MEMBERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { agentsList, branchId }) => {
    commit(SET_BRANCH_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      const response = await BranchesAPI.updateAgents({
        agentsList,
        branchId,
      });
      commit(ADD_AGENTS_TO_BRANCH, response);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_BRANCH_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [SET_BRANCH_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [ADD_AGENTS_TO_BRANCH]($state, { data, branchId }) {
    $state.records = {
      ...$state.records,
      [branchId]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
